module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "normal-d"
  }, [_vm._v("The wrath of the lion"), _c('br'), _vm._v("is the wisdom of God."), _c('br'), _vm._v("—William Blake ("), _c('i', [_vm._v("Proverbs of Hell")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "normal-d1"
  }, [_vm._v("Wednesday’s child is full of woe,"), _c('br'), _vm._v("Thursday’s child has far to go."), _c('br'), _vm._v("—Nursery Rhyme")]), _vm._v(" "), _c('p', {
    staticClass: "normal-d1"
  }, [_vm._v("The wrath of the lion"), _c('br'), _vm._v("may see me through Wednesday"), _c('br'), _vm._v("But where the hell do I go"), _c('br'), _vm._v("after that?"), _c('br'), _vm._v("—Mack Bolan, the Executioner")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27645da5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm.vue
// module id = 75
// module chunks = 0